module.exports = __webpack_public_path__ + "img/GERA_Unternehmen_Pic1.jpg";